import {useState, useCallback} from "react";
import {AlertPopperProps} from "../components/AlertPopper/AlertPopper";

type AlertPopperConfig = Omit<
  AlertPopperProps,
  "open" | "anchorEl" | "onClose"
>;

export const useAlertPopper = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [config, setConfig] = useState<AlertPopperConfig | null>(null);

  const openAlert = useCallback(
    (element: HTMLElement, newConfig: AlertPopperConfig) => {
      setAnchorEl(element);
      setConfig(newConfig);
      setIsOpen(true);
    },
    [],
  );

  const closeAlert = useCallback(() => {
    setIsOpen(false);
    setAnchorEl(null);
    setConfig(null);
  }, []);

  return {
    isOpen,
    anchorEl,
    config,
    openAlert,
    closeAlert,
  };
};
